import { render, staticRenderFns } from "./IntegracaoManage.vue?vue&type=template&id=460957ea&scoped=true"
import script from "./IntegracaoManage.vue?vue&type=script&lang=js"
export * from "./IntegracaoManage.vue?vue&type=script&lang=js"
import style0 from "./IntegracaoManage.vue?vue&type=style&index=0&id=460957ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460957ea",
  null
  
)

export default component.exports